import {gql} from "@apollo/client";

// One chat session per report; created lazily when the user sends their
// first message. Existing sessions come via report.oneAiChatSession.
export const CreateRiskAssessmentReportOneAiChatSession = gql`
    mutation CreateRiskAssessmentReportOneAiChatSession($riskAssessmentReportId: ID!) {
        createRiskAssessmentReportOneAiChatSession(riskAssessmentReportId: $riskAssessmentReportId) {
            id
        }
    }
`;
